import PropTypes from 'prop-types';
import {Switch, Redirect, Route, useLocation} from 'react-router-dom';

import DiscoverBdrBox from '../DiscoverBdrBox';
import SentInvitations from '../SentInvitations';
import InvalidOrganisationDocuments from '../invalidOrganisationDocuments';

import {useSubcontractorsStore} from './SubcontractorsStore';
import Header from './header';
import Tabs from './tabs';
import SubcontractorsList from './SubcontractorsList';

function SubcontractorsView(props) {
  const {state: {subcontractors, sentInvitations}, dispatch} = useSubcontractorsStore();
  const location = useLocation();

  return (
    <>
      <Header/>

      <DiscoverBdrBox/>

      <Tabs/>

      <div className="mb-5">
        <Switch>
          <Redirect
            data-id="redirect-accept-relationship"
            from="/subcontractors"
            exact
            to={`/subcontractors/list${location.search}`}
          />
          <Route
            exact
            path="/subcontractors/list"
            component={SubcontractorsList}
          />
          <Route
            exact
            path="/subcontractors/invitations-sent"
            render={() => (
              <SentInvitations
                error={sentInvitations.error}
                loading={sentInvitations.loading}
                sentInvitations={sentInvitations.list}
                onRefreshRequested={() => dispatch({type: 'FETCH_DATA'})}
                isSubcontractorView
              />
            )}
          />
          <Route
            exact
            path="/subcontractors/invalid-organisation-documents"
            render={() => (
              <InvalidOrganisationDocuments
                country={subcontractors.dossierCountry}
                onGetDocuments={props.onGetDocuments}
              />
            )}
          />
        </Switch>
      </div>
    </>
  );
}

SubcontractorsView.propTypes = {
  onGetDocuments: PropTypes.func.isRequired
};

export default SubcontractorsView;
